var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.groupsStudents),function(group){return _c('div',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(group.groupNumber)+" група")]),_c('group-codes-print',{attrs:{"students":group.students}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }